import {Companies, Superstars} from "./models.js";

function Relationship() {

    // Boolean
    const interested = null;

    // String
    const type = null;

    // Foreign keys
    const superstarId = null;
    const companyId = null;

    return {
        interested,
        type,
        superstarId,
        companyId,
    };
}

function getRelationshipCompany(relationship) {
    return Companies.find({'$loki': relationship.companyId})[0];
}

function getRelationshipSuperstar(relationship) {
    return Superstars.find({'$loki': relationship.superstarId})[0];
}

export { Relationship, getRelationshipCompany, getRelationshipSuperstar }
